import { Spin } from 'antd'
import Tooltip from 'antd/es/tooltip'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import { StyledTable } from 'components/TableStyles/TableStyles'
import EditIcon from 'components/icons/EditIconBlue'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Drives/Components/DriveTable/Drivefilter/Style/style'
import { EmptyWrapper } from 'modules/Drives/Components/Styles/style'
import MultiCheckFilter from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ExternalAssesment/ExternalDriveFilter/SearchFilter/MultiCheckFilter.js'
import CandidateInfo from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/index'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ColumnHead } from '../../../../../components/TableStyles/TableContentStyles/ExternalContentStyles'
import {
  EmptyAnchor,
  EmptySpan,
} from '../../../../../components/UIComponents/CommonStyledDiv'
import DriveStatus from '../DriveStatus'
import ExternalDriveFilter from './ExternalDriveFilter'
import TestGorillaDrawer from './ScoreDrawer'
export const centerText = styled(Flex)`
  align-content: center;
`
const TruncatedTitle = styled.span`
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`
const AlignCenter = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
`
const CheckboxDiv = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
`

export const ExternalDriveTable = ({
  candidateScoreDeatils,
  setSelectedIds,
  selectedIds,
  getTopicsList,
  assessmentId,
  getCandidateScore,
  postPassingScore,
  searchName,
  setSearchName,
  driveData,
  scheduleDrawer,
  setScheduleDrawer,
  createSlotDrawer,
  setCreateSlotDrawer,
  candidateDetails,
  rolesMetrics,
  candidateInterviewDetails,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
  setReleaseOffer,
  isUpload,
  getCandidateDetails,
  setTopicsPayload,
  isLoading,
  setScoreSortBy,
  setCurrentScorePage,
  currentScorePage,
  setSearchScoreValue,
  searchScoreValue,
  isLoadingCandidate,
  filter,
  setFilter,
  isVisible,
  drive,
  count,
  subEvents,
  isMenuOpen,
  setIsMenuOpen,
}) => {
  const [topicsData, setTopicsData] = useState([])
  const [candidateInfo, setCandidateInfo] = useState(false)
  const [candidateInfoData, setCandidateInfoData] = useState({})
  const [candidateLoading, setCandidateLoading] = useState(false)
  const [driveStatus, setDriveStatus] = useState([])
  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId,
      setLoading: setCandidateLoading,
    })

    if (status >= 200 && status < 300) {
      setCandidateInfo(true)
    }
  }
  const isQualifiedTrue = candidateScoreDeatils?.candidateList?.find(
    item => item.student?.isQualified === true
  )

  const filterData = candidateScoreDeatils?.candidateList
  const columnDataSource = filterData?.map(studentData => {
    const studentId = studentData?.studentId
    const firstName = studentData?.firstName
    const middleName = studentData?.middelName
    const lastName = studentData?.lastName
    const isQualified = studentData?.isQualified
    const rating =
      studentData?.rating ?? studentData?.studentRoleMapping?.rating ?? ''
    const stage = studentData?.stage ?? ''
    const studentName = [firstName, middleName, lastName]
      .filter(Boolean)
      .join(' ')
    const status = studentData?.status
    const topics = studentData?.topics?.reduce((acc, topic) => {
      acc[topic?.extAssmntTopics?.name] = topic?.score ? topic?.score : '-'
      return acc
    }, {})

    return {
      key: studentId,
      id: studentId,
      name: studentName,
      status: status,
      rating: rating,
      stage: stage,
      isQualified: isQualified,
      ...topics,
    }
  })

  const [topicList, setTopicList] = useState()
  const [testGorillaDrawer, setTestGorillaDrawer] = useState(false)
  const rowSelection = {
    selectedRowKeys: selectedIds,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedIds(selectedRowKeys || '')
    },

    getCheckboxProps: record => ({
      disabled: record.isQualified === true || record.status == 'ABSENT',

      isQualified: record.isQualified,
    }),
  }
  const handleSelectAll = () => {}

  const apiCall = async () => {
    if (assessmentId) {
      let response = await getTopicsList(assessmentId)
      if (response?.status >= 200 && response?.status <= 300) {
        setTopicList(response?.data?.data || [])

        setTopicsData(response?.data?.data || [])
      }
    }
  }
  useEffect(() => {
    if (assessmentId) {
      apiCall()
    }
  }, [assessmentId])

  const onClickEdit = async () => {
    let response = await getTopicsList(assessmentId)
    if (response?.status >= 200 && response?.status <= 300) {
      setTopicList(response?.data?.data || [])
      setTopicsData(response?.data?.data || [])
      setTestGorillaDrawer(true)
    }
  }

  const onClickDrawer = items => {
    setCandidateInfo(true)
    setSelectedCandidateId([items?.id])
    setSelectedCandidate([items?.name])
    studentDetailsAPI(items?.id)
    setCandidateInfoData(items)
  }
  useEffect(() => {
    if (topicList?.length > 0) {
      setTopicsData(topicList)
      const payload = {
        scores: topicList?.map(item => ({
          name: item.name,
          score: item.passingScore,
          topicId: item.id,
        })),
      }
      setTopicsPayload(payload)
    }
  }, [topicList])
  const onChange = (pagination, filters, sorter, extra) => {
    if (sorter?.order) {
      setScoreSortBy({ field: sorter?.field, order: sorter?.order })
    } else {
      setScoreSortBy({ sort: '', order: '' })
    }
  }

  const columns = [
    {
      title: <span> NAME </span>,
      dataIndex: 'firstName',
      sorter: (a, b) => a.name - b.name,
      width: '8%',
      fixed: 'left',
      align: 'left',
      style: {
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center',
      },
      background: false,
      render: name => <EmptyAnchor>{name}</EmptyAnchor>,
      children: [
        {
          render: (text, record) => (
            <EmptyAnchor
              style={{ color: 'blue' }}
              onClick={() => onClickDrawer(record)}
            >
              {record?.name}
            </EmptyAnchor>
          ),
          fixed: 'left',
          title: (
            <CheckboxDiv>
              <span style={{ fontSize: '1em', fontWeight: '600' }}>
                Set Qualifying Score
              </span>
              <EmptySpan style={{ cursor: 'pointer' }} onClick={onClickEdit}>
                <EditIcon />
              </EmptySpan>
            </CheckboxDiv>
          ),
          dataIndex: 'name',
          key: 'name',
          align: 'left',
          background: true,
        },
      ],
    },
    {
      title: (
        <ColumnHead>
          <Tooltip title="Status">
            <span>
              <TruncatedTitle>Status</TruncatedTitle>
            </span>
          </Tooltip>
        </ColumnHead>
      ),
      align: 'center',
      dataIndex: 'status',

      render: (text, record) => (
        <TruncatedTitle>
          <DriveStatus
            status={record?.isQualified ? 'QUALIFIED' : text}
            offerStatus={record.isQualified}
          />
        </TruncatedTitle>
      ),
      children: [
        {
          title: '',
          dataIndex: 'status',
          key: 'status',
          render: (text, record) => (
            <TruncatedTitle>
              <DriveStatus
                status={record?.isQualified ? 'QUALIFIED' : text}
                offerStatus={record.isQualified}
              />
            </TruncatedTitle>
          ),
        },
      ],
    },
    ...(topicsData?.map(topic => ({
      title: (
        <ColumnHead>
          <Tooltip title={topic.name} placement="bottom">
            <TruncatedTitle>{topic.name}</TruncatedTitle>
          </Tooltip>
        </ColumnHead>
      ),
      align: 'center',
      sorter: true,
      dataIndex: topic.id, // Use topic.id as the dataIndex
      style: {
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center',
      },
      render: text => text || '-', // Display "-" if the data is falsy (null, undefined, empty string, etc.)

      children: [
        {
          title: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.15em',
                fontWeight: '600',
              }}
            >
              {topic.passingScore || '-'}{' '}
            </div>
          ),
          render: text => text || 'NA', // Display "-" if the data is falsy (null, undefined, empty string, etc.)
          dataIndex: topic.name, // Use topic.id as the dataIndex
          key: topic.id, // Use topic.id as the key
          align: 'center',
        },
      ],
    })) || []),
  ]
  const onPageChange = pagNum => {
    setCurrentScorePage(pagNum - 1)
  }
  const onCancelFilter = e => {
    setDriveStatus(filter)
    setIsMenuOpen(false)
  }

  const onChangeFilet = e => {
    e.preventDefault()
    setFilter(driveStatus)
    setIsMenuOpen(false)
  }
  let filerItem = [
    {
      label: 'Status',
      key: '3',
      children: (
        <MultiCheckFilter
          driveStatus={driveStatus}
          setDrivestatus={setDriveStatus}
        />
      ),
    },
  ]
  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        items={filerItem}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={onCancelFilter} />
        <Button.Primary text="Apply Filter" onClick={onChangeFilet} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <>
      <div>
        <ExternalDriveFilter
          setOpen={setIsMenuOpen}
          open={isMenuOpen}
          menu={menu}
          isQualifiedTrue={isQualifiedTrue || false}
          setSearchValue={setSearchScoreValue}
          searchValue={searchScoreValue}
          candidateScoreDeatils={candidateScoreDeatils}
          currentCount={
            candidateScoreDeatils?.count < 10
              ? candidateScoreDeatils?.count || 0
              : (candidateScoreDeatils?.page + 1) * 10 -
                10 +
                candidateScoreDeatils?.candidateList?.length
          }
          totalCount={candidateScoreDeatils?.count}
          allIsTrue={isVisible}
          // onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
          hideSearchIcon
        />
        <StyledTable
          key={count}
          rowSelection={
            subEvents?.includes('BULK ACTION')
              ? { ...rowSelection, onSelectAll: handleSelectAll }
              : ''
          }
          columns={columns}
          rowKey={record => record.id}
          dataSource={columnDataSource}
          bordered
          pagination={false}
          onChange={onChange}
          scroll={{
            x: 1500,
          }}
          locale={{
            emptyText: (
              <EmptyWrapper column alignCenter isSpin={isLoading}>
                {!isLoading && columnDataSource?.length == 0 ? (
                  <Flex column alignCenter>
                    <centerText>
                      <EmptyCandidateIcon />
                    </centerText>
                    <centerText>
                      <centerText>No candidates found in this stage</centerText>
                    </centerText>
                    <centerText>
                      Please pick a stage from the funnel above to manage the
                      candidate's applications.
                    </centerText>
                  </Flex>
                ) : (
                  <Spin />
                )}
              </EmptyWrapper>
            ),
          }}
        />
        <Pagination
          onChange={onPageChange}
          totalPages={candidateScoreDeatils?.count}
          pageSize={10}
          current={currentScorePage + 1}
        />
      </div>
      <TestGorillaDrawer
        topicList={topicList}
        setTestGorillaDrawer={setTestGorillaDrawer}
        testGorillaDrawer={testGorillaDrawer}
        postPassingScore={postPassingScore}
        getCandidateScore={getCandidateScore}
        getTopicsList={getTopicsList}
        setTopicList={setTopicList}
        assessmentId={assessmentId}
        setTopicsData={setTopicsData}
      />
      <CandidateInfo
        candidateInfo={candidateInfo}
        setCandidateInfo={setCandidateInfo}
        driveData={driveData}
        scheduleDrawer={scheduleDrawer}
        setScheduleDrawer={setScheduleDrawer}
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        candidateDetails={candidateDetails}
        rolesMetrics={rolesMetrics}
        candidateInterviewDetails={candidateInterviewDetails}
        candidateInfoData={candidateInfoData}
        updateInterviewStatus={updateInterviewStatus}
        driveId={driveId}
        roleId={roleId}
        getCandidateList={getCandidateList}
        selectedRoundType={selectedRoundType}
        loading={candidateLoading}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidate={setSelectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        getSingleCandidateInterviewDetails={getSingleCandidateInterviewDetails}
        setReleaseOffer={setReleaseOffer}
        isUpload={isUpload}
      />
    </>
  )
}
